module.exports = __webpack_public_path__ + "static/media/moviRec.c542824f.png";